export const IS_MAC_OS = navigator.userAgent.toLowerCase().includes("macintosh")

export const formatKeyboardShortcut = (shortcut) => {
  return shortcut
    .split("+")
    .map((part) => {
      switch (part) {
        case "meta":
          return IS_MAC_OS ? "⌘" : "⊞"
        case "ctrl":
          return "⌃"
        case "alt":
          return IS_MAC_OS ? "⌥" : "alt"
        case "option":
          return IS_MAC_OS ? "⌥" : "alt"
        case "shift":
          return "⇧"
        case "enter":
          return "↵"
        case "slash":
          return "/"
        default:
          return part
      }
    })
    .join("+")
}

// In react-hotkeys-hook v5, use key code names (e.g., "slash" instead of "/")
export const TIME_DETECTIVE_SHORTCUT_KEY = IS_MAC_OS ? "meta+slash" : "ctrl+slash"
export const SEARCH_PANEL_SHORTCUT_KEY = IS_MAC_OS ? "meta+k" : "ctrl+k"
export const SIDEBAR_TOGGLE_SHORTCUT_KEY = IS_MAC_OS ? "meta+alt+b" : "ctrl+alt+b"
export const SUBMIT_NOTE_SHORTCUT_KEY = IS_MAC_OS ? "meta+enter" : "ctrl+enter"
export const SELECT_SINGLE_NAMESPACE_SHORTCUT_KEY = IS_MAC_OS ? "option+click" : "alt+click"
